// admins/human-resources
import React from 'react';
import View from 'src/pages/coming-soon';
import AppRender from 'src/routes/app-render';

const Page = () => {
  return (
    <AppRender>
      <View message={'Quản lý nhân sự. Phân nhân viên theo đơn vị'} />
    </AppRender>
  );
};

export default Page;
